import { ReactNode, useEffect, useRef } from "react";
import { ModalContainer } from "./ModalStyles";
import { v4 as uuidv4 } from "uuid";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/store";
import { addToStack, removeFromStack } from "../../../reducers/modals";

interface ModalProps {
  children: ReactNode;
  isOpen?: boolean;
  onRequestClose?: () => void;
}

export default function Modal({
  children,
  isOpen,
  onRequestClose,
}: ModalProps) {
  const dispatch = useAppDispatch();
  const modalIdRef = useRef(uuidv4());
  const stack = useAppSelector((state) => state.modals.stack);

  useEffect(() => {
    const modalId = modalIdRef.current;
    if (isOpen) {
      dispatch(addToStack({ modalId: modalId }));
    } else {
      dispatch(removeFromStack({ modalId: modalId }));
    }
    return () => {
      dispatch(removeFromStack({ modalId: modalId }));
    };
  }, [dispatch, isOpen]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.key === "Escape" &&
        onRequestClose !== undefined &&
        stack.at(-1) == modalIdRef.current
      ) {
        onRequestClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onRequestClose, stack]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (isOpen) {
    return <ModalContainer>{children}</ModalContainer>;
  }
  return null;
}
